import React, { FC } from "react";
import cn from "classnames";
import { IOptionSelect, OptionValue, SetOptionValue } from "src/@types/form";
import { ButtonSelectorItem } from "./ButtonSelectorItem";

interface Props {
  options: IOptionSelect[];
  activeValue: OptionValue;
  setActiveValue: SetOptionValue;
  className?: string;
}
export const SingleButtonSelector: FC<Props> = ({
  options,
  activeValue,
  setActiveValue,
  className,
}) => {
  const isActive = (value: OptionValue) => value === activeValue;
  const handleClick = (value: OptionValue) => () => setActiveValue(value);

  return (
    <div
      className={cn(
        "flex items-center justify-center w-full border rounded-lg lg:w-11/12",
        className
      )}
    >
      {options.map((option) => (
        <ButtonSelectorItem
          key={option.id}
          option={option}
          isActive={isActive(option?.value)}
          onClick={handleClick(option?.value)}
        />
      ))}
    </div>
  );
};
